import styled from 'styled-components';

export const OneProject = styled.div`
  background-color: #262626;
  padding: 20px;
  border-radius: 6px;
  display: grid;
  gap: 2px;
  justify-items: center;
  box-shadow: 
    0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`


